import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar'
import DropdownButton from 'react-bootstrap/lib/DropdownButton'
import MenuItem from 'react-bootstrap/lib/MenuItem'
import PropTypes from 'prop-types'
import React, {Component, Fragment} from 'react'
import {Transition} from 'react-transition-group'
import {css} from 'glamor'

import Button from '../../../../components/button'
import Icon, {icons} from '../../../../components/icon'
import Review from './review'
import ReviewPlaceholder from './reviewPlaceholder'
import {colors, palettes, text} from '../../../../styles'
import {fadeInOutStyle} from '../../sharedStyles'

export const REVIEWS_COUNT = 5

export const REVIEWS_SORT = {
  NEWEST: '0',
  RATINGS_DESC: '1',
  RATINGS_ASC: '2',
  ONE_STAR: '3',
  TWO_STARS: '4',
  THREE_STARS: '5',
  FOUR_STARS: '6',
  FIVE_STARS: '7'
}

const REVIEWS_SORT_LABELS = {
  [REVIEWS_SORT.NEWEST]: 'Newest',
  [REVIEWS_SORT.RATINGS_DESC]: 'Ratings (highest to lowest)',
  [REVIEWS_SORT.RATINGS_ASC]: 'Ratings (lowest to highest)',
  [REVIEWS_SORT.ONE_STAR]: '1 star',
  [REVIEWS_SORT.TWO_STARS]: '2 stars',
  [REVIEWS_SORT.THREE_STARS]: '3 stars',
  [REVIEWS_SORT.FOUR_STARS]: '4 stars',
  [REVIEWS_SORT.FIVE_STARS]: '5 stars'
}

const style = {
  noReviews: css(text.bodyHeader, {
    borderBottom: `1px solid ${colors.grayLighter}`,
    color: colors.gray46,
    marginTop: '40px',
    paddingBottom: '40px',
    textAlign: 'center',
    '@media (max-width: 767px)': {
      margin: '10px -15px 0',
      padding: '20px 0 30px'
    }
  }),
  reviewsList: css({
    marginBottom: '20px'
  }),
  reviewsMoreButton: css({
    display: 'block',
    margin: '0 auto'
  }),
  reviewsSorting: css(text.bodySmallBold, {
    borderBottom: `1px solid ${colors.grayLighter}`,
    color: colors.grayMedium,
    paddingBottom: '15px',
    margin: '40px -15px 0',
    textAlign: 'center'
  }),
  reviewsSortingToolbar: css({
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    '& .open > .dropdown-toggle': {
      boxShadow: 'none',
      '&.btn-default': {
        backgroundColor: palettes.outline.state.active
      }
    }
  }),
  reviewsSortingButton: css({
    background: palettes.outline.base,
    border: `1px solid ${colors.gray77}`,
    borderRadius: '3px',
    cursor: 'pointer',
    display: 'inline-block',
    height: '36px',
    lineHeight: '36px',
    margin: 0,
    padding: '0 25px',
    position: 'relative',
    textAlign: 'center',
    textDecoration: 'none',
    textTransform: 'uppercase',
    '&:focus': {
      backgroundColor: palettes.outline.state.focus,
      textDecoration: 'none'
    },
    '&:hover': {
      backgroundColor: palettes.outline.state.hover,
      textDecoration: 'none'
    },
    '&:disabled': {
      backgroundColor: palettes.disabled.base,
      color: palettes.disabled.text,
      cursor: 'not-allowed',
      textShadow: 'none',
      pointerEvents: 'none'
    },
    '&:active, &:active:focus, &:active:hover, &.active, &.active:hover': {
      backgroundColor: palettes.outline.state.active,
      boxShadow: 'none'
    }
  })
}

class ProductReviews extends Component {
  hasMoreReviews() {
    const {totalCount, reviews} = this.props
    return reviews && reviews.length && reviews.length < totalCount
  }

  hasNoReviews() {
    const {loading, reviews} = this.props
    return !loading && reviews && reviews.length === 0
  }

  render() {
    const {totalCount, loading, onMore, onSort, reviews, sort} = this.props

    return (
      <div className="reviewsContainer">
        {totalCount ? (
          <div {...style.reviewsSorting}>
            <ButtonToolbar {...style.reviewsSortingToolbar}>
              <div>Sort By</div>
              <DropdownButton
                id="sort-criteria"
                onSelect={(key) => onSort(key)}
                noCaret
                title={
                  <span>
                    {REVIEWS_SORT_LABELS[sort]}{' '}
                    <Icon icon={icons.chevronDown} />
                  </span>
                }
                {...style.reviewsSortingButton}
              >
                {Object.values(REVIEWS_SORT).map((key) => (
                  <MenuItem key={key} eventKey={key}>
                    {REVIEWS_SORT_LABELS[key]}
                  </MenuItem>
                ))}
              </DropdownButton>
            </ButtonToolbar>
          </div>
        ) : null}
        {this.hasNoReviews() ? (
          <Transition in={true} timeout={250}>
            {(state) => (
              <div {...css(fadeInOutStyle.container, fadeInOutStyle[state])}>
                <p {...style.noReviews}>No reviews currently available.</p>
              </div>
            )}
          </Transition>
        ) : (
          <Fragment>
            <div {...style.reviewsList}>
              {reviews &&
                reviews.map((review) => (
                  <Review key={review.ID} review={review} />
                ))}
            </div>
            <ReviewPlaceholder in={loading} count={REVIEWS_COUNT} />
            {this.hasMoreReviews() && (
              <Button
                kind="outline"
                onClick={onMore}
                size="small"
                style={style.reviewsMoreButton}
              >
                Show More
              </Button>
            )}
          </Fragment>
        )}
      </div>
    )
  }
}

ProductReviews.propTypes = {
  totalCount: PropTypes.number,
  loading: PropTypes.bool,
  onSort: PropTypes.func.isRequired,
  onMore: PropTypes.func,
  reviews: PropTypes.arrayOf(PropTypes.object),
  sort: PropTypes.string.isRequired
}

export default ProductReviews
